import { useEffect, useState } from 'react';
import { Box, Divider } from '@mui/material';
import type { Order } from '../../api/order';
import OrderDetailHeader from '../pages/OrderDetail/OrderDetailHeader';
import OrderDetailView from '../pages/OrderDetail/OrderDetailView';
import { useOrderDetailHandlers } from '../pages/OrderDetail/useOrderDetailHandlers';

interface OrderRowDetailsProps {
  order: Order;
  onUpdated: () => void;
}

const OrderRowDetails = ({ order, onUpdated }: OrderRowDetailsProps) => {
  const [orderState, setOrderState] = useState(order);

  useEffect(() => {
    setOrderState(order);
  }, [order]);

  const { handleUpdated, historyRefreshKey } = useOrderDetailHandlers({
    onRefresh: onUpdated,
    onApplyOrder: setOrderState,
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <OrderDetailHeader
        order={orderState}
        onUpdated={handleUpdated}
        onDeleted={onUpdated}
      />
      <Divider />
      <OrderDetailView
        order={orderState}
        onUpdated={handleUpdated}
        historyRefreshKey={historyRefreshKey}
      />
    </Box>
  );
};

export default OrderRowDetails;
